import { render, staticRenderFns } from "./ProcessesReport.vue?vue&type=template&id=1f1dcc24&scoped=true"
import script from "./ProcessesReport.vue?vue&type=script&lang=js"
export * from "./ProcessesReport.vue?vue&type=script&lang=js"
import style0 from "./ProcessesReport.vue?vue&type=style&index=0&id=1f1dcc24&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f1dcc24",
  null
  
)

export default component.exports